import { eachDayOfInterval, endOfMonth, format, startOfMonth } from 'date-fns';
import { getGoalProgressPercentage } from '.';
import { Goal } from '../types';

type MonthGridData = { [key: string]: MonthGridTileData };

interface MonthGridTileData {
  date?: Date;
  success?: boolean;
}

/** Gets data for displaying a month grid of goal completions */
export function getGoalMonthGridData(
  this: Goal,
  date: Date,
  user_id: string
): MonthGridData {
  const daysOfMonth = eachDayOfInterval({
    start: startOfMonth(date),
    end: endOfMonth(date),
  });

  return daysOfMonth.reduce<MonthGridData>(
    (acc, day) => ({
      ...acc,
      [format(day, 'yyyy-MM-dd')]: {
        date: day,
        success:
          getGoalProgressPercentage(this, { date: day, user_id }) === 100,
      },
    }),
    {}
  );
}
